<div class="list-forms" *ngIf="!selectedForm">
    <div id="kt_open_create_drawer" (click)="openDefaultActivityForm()" class="btn btn-outline-primary form-name-act">
        <i class="fa fa-plus">
        </i> {{ l('AllocationActivity') }}
    </div>
    <div *ngFor="let form of formsList" (click)="onClick(form)" class="btn btn-outline-primary form-name-act">
        <i class="fa fa-plus"></i> {{form.name}}
    </div>
</div>

<div *ngIf="selectedForm">
    <app-activities-create-panel isDynamicForm="true" (onCreated)="activityCreated()" [selectedForm]="selectedForm"
        (onClosePanel)="closeDrawer()" (onOpenFormPanel)="openFormPanel()">
    </app-activities-create-panel>
</div>
